export const DEFAULT_LCID = 1033;

export const TERMSET_QUERY_IDS = 'ids';
export const TERMSET_QUERY_LABEL = 'label';